'use strict';

function CompanyCustomerCategoriesService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/customers/categories/:categoryId', {}, {
    'update':  {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyCustomerCategoriesService', ['$resource', 'config', CompanyCustomerCategoriesService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customers/categories/CompanyCustomerCategoriesService.js
// module id = 336
// module chunks = 0